var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orders-form-controls"},[_c('div',{staticClass:"fabs"},[_c('div',{staticClass:"fabs__container"},[_c('div',{staticClass:"fabs__buttons"},[_vm._t("default"),_vm._v(" Form Actions ")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }